import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface VerticalContentCollectionProps {
  className?: string
}

const VerticalContentCollection: React.FC<
  React.PropsWithChildren<VerticalContentCollectionProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;

        & > *:nth-child(n + 2) {
          margin-top: ${styleConstants.heights.minorInternalGutter};
        }
      `}
    >
      {props.children}
    </div>
  )
}

export default VerticalContentCollection
